


import Footer from './Component/Footer';
import Navbaar from './Component/Navbaar';
import Srouter from './Srouter';

function App() {
  return (
    <>
    
    <Navbaar />
    <Srouter />
    <Footer />
    </>
  );
}

export default App;
